import { render, staticRenderFns } from "./ImagePickerDuplicatedCover.vue?vue&type=template&id=e0c9f6b2&"
import script from "./ImagePickerDuplicatedCover.vue?vue&type=script&lang=js&"
export * from "./ImagePickerDuplicatedCover.vue?vue&type=script&lang=js&"
import style0 from "./ImagePickerDuplicatedCover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports